import { Suspense } from 'react';
import { Canvas } from '@react-three/fiber';
import { Environment, OrbitControls } from '@react-three/drei';
import * as THREE from 'three';
import { Blob } from './Blob';
import { BLOB_CONFIG } from './blobConfig';
import { STUDIO_ENVIRONMENT_HDRI } from '../../config/environmentHdri';

export function BlobScene({ gradientColor1, gradientColor2, gradientColor3, configOverride, baseConfig = BLOB_CONFIG }) {
  const cfg = configOverride ? { ...baseConfig, ...configOverride } : baseConfig;
  return (
    <Canvas
      camera={{ position: [0, 0, 4.5], fov: 75 }}
      gl={{
        toneMapping: THREE.ACESFilmicToneMapping,
        toneMappingExposure: 1,
      }}
      dpr={[1, 2]}
    >
      <color attach="background" args={[cfg.background]} />
      <OrbitControls
        enablePan={false}
        autoRotate={cfg.autoRotate}
        autoRotateSpeed={cfg.autoRotateSpeed}
      />
      <Suspense fallback={null}>
        <Blob
          gradientColor1={gradientColor1}
          gradientColor2={gradientColor2}
          gradientColor3={gradientColor3}
          config={cfg}
        />
        <Environment files={STUDIO_ENVIRONMENT_HDRI} />
      </Suspense>
    </Canvas>
  );
}
